import { IFamilyMember } from "@app-types/websocket/family.types";
import { FamilyMemberType } from './family.constants';

const standardFamilyColors:string[] = ["#ef5a62","#acc3f2","#ffd776","#7fc5cb","#e3df81","#ff924e","#ec64a6",
  "#b9e0d1","#f97f94", "#9fd46e", "#c68bfa", "#c97d5d"];
const admin:string = "#bc9892";

const getFamilyColors = (data:IFamilyMember[], update?:{userId:number, color:string}):string[] => {

  const colors = standardFamilyColors.slice();

  data.sort((a,b) => (a.id - b.id));
  let index = 0;
  for (const mem of data) {
    if (mem.role === FamilyMemberType.MODERATOR || mem.role === FamilyMemberType.EXPERT ) {
      // do nothingmem.color = admin;
    } else {
      if (index >= colors.length) {
        if (update && update.userId === mem.id) {
          colors.push(update.color);
        } else {
          colors.push(mem.color);
        }
      } else {
        if (update && update.userId === mem.id) {
          colors[index] = update.color;
        } else {
          colors[index] = mem.color;
        }
      }
      index++;
    }
  }

  return colors;
}

const enrichFamilyData = (data:IFamilyMember[], familyColor:string[], onlyOnMemId?:number):IFamilyMember[] => {
  data.sort((a,b) => (a.id - b.id));
  let index = 0;
  for (const mem of data) {
    if (mem.role === FamilyMemberType.MODERATOR || mem.role === FamilyMemberType.EXPERT ) {
      mem.color = admin;
    } else {
      if (onlyOnMemId === undefined || onlyOnMemId === mem.id) {
        mem.color = familyColor[index%familyColor.length];
      }
      index++;
    }
  }

  return data;
};

// True when nobody but me was ever invited to or has logged in to the group. Members removed from it no longer count.
const isGroupOnlyMine = (family:IFamilyMember[], myId:number):boolean =>
  family.some((mem) => mem.id === myId)
  && family.every((mem) => mem.id === myId || mem.role === FamilyMemberType.DELETED
    || (!mem.online && !(mem.inviteTime > 0) && !(mem.lastOnline > 0)));

export { enrichFamilyData, standardFamilyColors, getFamilyColors, isGroupOnlyMine};



// WEBPACK FOOTER //
// ./src/services/family/family.utils.ts